import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_7 = {
  key: 0,
  style: {"color":"#909399"}
}
const _hoisted_8 = {
  key: 1,
  style: {"color":"#67c23a"}
}
const _hoisted_9 = {
  key: 2,
  style: {"color":"#f56c6c"}
}
const _hoisted_10 = {
  key: 3,
  style: {"color":"#e6a23c"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 撤回 ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "用户：", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("strong", null, "赠送类型：", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "商品：", -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "数量：", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"#e6a23c","margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "警告："),
  /*#__PURE__*/_createTextVNode("撤回后将从用户账户中扣除相应的余额/积分或删除背包商品，请谨慎操作！ ")
], -1)
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 确认撤回 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.newGiftRecord,
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, {
            field: "mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.mobile,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                placeholder: "手机号码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.duration,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.duration) = $event)),
                type: "datetimerange",
                "range-separator": " - ",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_vxe_button, {
                type: "button",
                onClick: _ctx.onDownload
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID"
        }),
        _createVNode(_component_vxe_column, {
          field: "user_name",
          title: "用户名称"
        }),
        _createVNode(_component_vxe_column, {
          field: "mobile",
          title: "用户手机号"
        }),
        _createVNode(_component_vxe_column, {
          field: "gift_type_display",
          title: "赠送类型"
        }),
        _createVNode(_component_vxe_column, {
          field: "product_name",
          title: "商品名称"
        }),
        _createVNode(_component_vxe_column, {
          field: "recycle_price",
          title: "商品回收价"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(row.recycle_price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "balance",
          title: "赠送数量"
        }),
        _createVNode(_component_vxe_column, {
          field: "status",
          title: "状态",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "待发放"))
              : (row.status === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已发放"))
                : (row.status === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已撤回"))
                  : (row.status === 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "发放失败"))
                    : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_at",
          title: "更新时间",
          width: "200"
        }),
        _createVNode(_component_vxe_column, {
          field: "updated_by",
          title: "更新人"
        }),
        _createVNode(_component_vxe_column, {
          title: "操作",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.status === 1)
              ? (_openBlock(), _createBlock(_component_vxe_button, {
                  key: 0,
                  type: "button",
                  status: "danger",
                  onClick: ($event: any) => (_ctx.handleAbort(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.abortDialog.visible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.abortDialog.visible) = $event)),
      title: "撤回赠送记录",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.abortDialog.visible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.confirmAbort,
            loading: _ctx.abortDialog.loading
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.abortDialog.record)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", null, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.abortDialog.record.user_name) + " (" + _toDisplayString(_ctx.abortDialog.record.mobile) + ")", 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_14,
                _createTextVNode(_toDisplayString(_ctx.abortDialog.record.gift_type_display), 1)
              ]),
              (_ctx.abortDialog.record.product_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(_toDisplayString(_ctx.abortDialog.record.product_name) + " (回收价: " + _toDisplayString(_ctx.formatPrice(_ctx.abortDialog.record.recycle_price)) + ") ", 1)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(_toDisplayString(_ctx.abortDialog.record.balance), 1)
                  ])),
              _hoisted_19,
              _createVNode(_component_el_input, {
                modelValue: _ctx.abortDialog.reason,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.abortDialog.reason) = $event)),
                type: "textarea",
                rows: 3,
                placeholder: "撤回原因（选填）",
                style: {"margin-top":"15px"}
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}